import React from 'react';
import { Icon } from '../../../Icon';
export const ColumnFilterCellIcon = () => React.createElement(Icon, { source: "Search" });
//# sourceMappingURL=ColumnFilterCellIcon.js.map